import { useContext, useEffect, useMemo, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { BarLoader, ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
// import Lightbox from "yet-another-react-lightbox-lite";
// import "yet-another-react-lightbox-lite/styles.css";
import { TostMessageContext } from "../context/TostMessage";
import { FaBold, FaItalic } from "react-icons/fa";

export function SendEmail({ setShowEmailModal, showDetails }) {
    const [pageLoading, setPageLoading] = useState(false);
    const [cookies, ] = useCookies();
    const { setTostMessage } = useContext(TostMessageContext);
    const [formFields, setFormFields] = useState({});
    const [fontSize, setFontSize] = useState(3); // 1–7 (default = 3)
    const editorRef = useRef(null);
    const [content, setContent] = useState("");

    const increaseFontSize = () => {
        const newSize = Math.min(fontSize + 1, 7);
        setFontSize(newSize);
        exec("fontSize", newSize);
    };

    const decreaseFontSize = () => {
        const newSize = Math.max(fontSize - 1, 1);
        setFontSize(newSize);
        exec("fontSize", newSize);
    };

    const exec = (command, value = null) => {
        editorRef.current?.focus();
        document.execCommand(command, false, value);
        setContent(editorRef.current.innerHTML);
    };

    const submit = async () => {
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData.append('customer', showDetails?.email);

        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/send_email.php', formData, {
                headers: {
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            setPageLoading(false)
            if (response.data.status) {
                setTostMessage({
                    messageType: 'success',
                    message: response.data.message
                })
                if (editorRef.current) {
                    editorRef.current.innerHTML = "";
                }
                setFormFields({});
                setContent('');
            } else {
                setTostMessage({
                    messageType: 'error',
                    message: response.data.message
                })
            }
        } catch (error) {
            setPageLoading(false)
            setTostMessage({
                messageType: 'error',
                message: 'Network Error'
            })
        }
    }

  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 px-5 h-full overflow-y-auto w-[100%] lg:w-[50%] fixed right-0 bg-white animate-scaleIn'>
                <div onClick={() => setShowEmailModal(false)} className='w-auto self-end flex justify-end text-underline text-[#ff0000] cursor-pointer'>Close</div>
                <a className='text-dark text-[20px] font-bold'>{'Send Email: ' + showDetails?.email}</a>
                <div className="flex inline-flex flex-wrap w-full justify-between">
                    <div className='w-[45%]'>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Title <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            className="h-[45px] w-full px-3 py-1 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                            placeholder="Enter email title"
                            onChange={(e) => setFormFields({...formFields, title: e.target.value})}
                        />
                    </div>
                    <div className="w-full mt-3 flex flex-col gap-y-2">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Email Body <span className="text-red-500">*</span>
                        </label>
                        <div className="flex flex-wrap gap-2 border rounded-lg p-2 bg-white">
                            <button size="sm" variant="outline" onClick={() => exec("bold")}>
                            <FaBold size={16} />
                            </button>
                            <button size="sm" variant="outline" onClick={() => exec("italic")}>
                            <FaItalic size={16} />
                            </button>
                            {/* Decrease font size */}
                            <button
                                type="button"
                                onClick={decreaseFontSize}
                                className="border rounded px-2 py-1 text-sm"
                            >
                                A-
                            </button>

                            {/* Increase font size */}
                            <button
                                type="button"
                                onClick={increaseFontSize}
                                className="border rounded px-2 py-1 text-sm"
                            >
                                A+
                            </button>

                            {/* Font color */}
                            <input
                                type="color"
                                onChange={(e) => exec("foreColor", e.target.value)}
                                className="w-8 h-8 p-0 border rounded cursor-pointer"
                                title="Text color"
                            />
                        </div>
                        <div
                            ref={editorRef}
                            contentEditable
                            className="min-h-[300px] bg-[#ffffff] border rounded-lg p-4 bg-white focus:outline-none"
                            placeholder="Write your post content here..."
                            onInput={() => {setContent(editorRef.current.innerHTML); setFormFields({...formFields, email_body: editorRef.current.innerHTML }) }}
                        />

                        {/* Preview / Debug */}
                        {/* <div className="text-sm text-gray-500">
                            <p>Email Preview:</p>
                            <pre className="bg-gray-100 p-2 rounded text-xs overflow-x-auto">
                            {content}
                            </pre>
                        </div> */}
                    </div>
                    <div className='w-full mt-3 flex justify-end'>
                        <button 
                            className="px-5 bg-secondary h-[40px] flex items-center justify-center text-white w-auto rounded hover:bg-secondary"
                            onClick={() => pageLoading ? null : submit()}>
                            Send
                        </button>
                    </div>
                    {pageLoading &&
                        <div className="bg-white mx-auto my-3 flex items-center justify-center">
                            <BarLoader 
                                color={'#7d5af6'}
                                loading={true}
                                size={10}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                        </div>
                    }
                </div>
                
            </div>  
        </div>
    )
}
